// 统一请求路径前缀在libs/axios.js中修改
import {getRequest, postRequest} from '@/libs/axios';


// 添加
export const add = (params) => {
    return postRequest('/base/vipprice/add', params)
}

// 修改
export const update = (params) => {
    return postRequest('/base/vipprice/update', params)
}
// 删除
export const remove = (ids) => {
    return postRequest("/base/vipprice/remove", {
        ids: ids
    })
}

// 列表
export const list = (params) => {
    return postRequest('/base/vipprice/list', params)
}

// 获取单个对象
export const get = (id) => {
    return getRequest(`/base/vipprice/get/${id}`)
}